"use client"

import { useEffect } from "react"
import type { FlowCallbacks } from "../../stores/flowCallbackStore"
import { FlowCallbackActions } from "../../stores/flowCallbackStore"

export function useFlowEventHandlers({
  onEnd,
  onStart,
  onSuccess,
  onError,
  options,
}: FlowCallbacks = {}) {
  useEffect(() => {
    if (!(onEnd || onStart || onSuccess || onError)) {
      return
    }
    return FlowCallbackActions.addCallbacks({
      onEnd,
      onStart,
      onSuccess,
      onError,
      options,
    })
  }, [onEnd, onStart, onSuccess, onError, options])

  return { addFlowEventHandler: FlowCallbackActions.addCallbacks }
}
